import Login from './container';

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login/index.js